import { BsCheckLg } from 'react-icons/bs';
import Select from 'react-select';
import { ClearanceStatusEnum } from '../../../api';

interface ClearanceControlProps {
  clearanceStatus: ClearanceStatusEnum;
  onClearanceStatusChange: (status: ClearanceStatusEnum) => void;
  isDisabled?: boolean;
}

const CustomOption = ({ label }: { label: string; value: ClearanceStatusEnum }) => {
  return (
    <>
      <BsCheckLg className="status-select__icon me-2" /> {label}
    </>
  );
};
export const ClearanceControl = ({
  clearanceStatus,
  onClearanceStatusChange,
  isDisabled,
}: ClearanceControlProps) => {
  return (
    <Select
      className="status-select"
      classNamePrefix="status-select"
      options={Object.values(ClearanceStatusEnum)
        .filter((status) => {
          if (clearanceStatus !== ClearanceStatusEnum.PENDING_CLEARANCE) {
            return status !== ClearanceStatusEnum.PENDING_CLEARANCE;
          }
          return true;
        })
        .map((status) => ({
          label:
            status === ClearanceStatusEnum.PENDING_CLEARANCE
              ? 'Set Clearance Status'
              : window.CLEARANCE_STATUS[status],
          value: status,
        }))}
      formatOptionLabel={CustomOption}
      isSearchable={false}
      isDisabled={isDisabled}
      value={{
        label:
          clearanceStatus === ClearanceStatusEnum.PENDING_CLEARANCE
            ? 'Set Clearance Status'
            : window.CLEARANCE_STATUS[clearanceStatus],
        value: clearanceStatus,
      }}
      onChange={(options) => {
        if (!options?.value) return;

        onClearanceStatusChange(options?.value);
      }}
    />
  );
};
